import { batch } from "react-redux";
import { getPricingDataForLeanto, handleLeanPorchPrices, selectCenterBuilding } from "..";
import { getLeanToBuildingPricing } from "../../helpers/building_pricing/buildingPricing.helper";
import { params } from "../../redux/reducers/common/stateObjects";
import { const_var } from "../../redux/reducers/common/stateObjects";
import { applicableWainscot } from "../../helpers/building/building_color/wainscotColor.helper";
import { checkAndupdateOtherInsulationSelection } from "../../helpers/insulation_pricing/insulationPricing.helper";
import { checkleanLegsDataAccordingtoResponse } from "../../helpers/building_component/legs_condition.helper";
import { setZeroPriceOverhang } from "../../helpers/extra_options_pricing/overhangPricing";
export const closeAddGableLeanBuildingModal = () => {
	return (dispatch) => {
		dispatch({
			type: "SET_ADD_GABLE_LEAN_TOGGLE_VISIBILITY",
			value: true
		});
	};
};
export const selectLeanBuilding = (leanType, switchType = false) => {
	return (dispatch) => {
		dispatch({
			type: "SELECT_LEAN_BUILDING",
			leanType: leanType,
			switchType: switchType
		});
	};
};
export const createGetPricingDataForLeanto = (deps) => {
	const { params, const_var, utils, cuBuilding, Constant, setPricingDataForLeanto, resetCheckBoxQuantityExtraBowsPrice } = deps;
	function getPricingDataForLeanto(e, type, chk, flag, legstype, insulation, forLeanRoofReset) {
		params.apiCallAfterEdit = false;
		const_var.is_loader = true;
		let leanMapId = utils.getLeantoMapId();
		let str = "";
		let porchLengthEnd = 0;
		let porchLengthSide = 0;
		let utilitWidth = 0;
		let exactCalculation = 0;

		const getMapIdForLeanTo = (leanType) => {
			if (const_var.isLTBuilding && params.leanStyle[leanType] === "gable") {
				return const_var?.c_m_a?.[params.p_b_t]?.gable_mapping?.[0]?.map_id;
			}
			return leanMapId;
		};

		if (params.cB_addStorage_check_right || params.cB_addStorage_check_left) {
			utilitWidth = params.cB_addStorage_check_right == true ? params.cB_addStorage_right : params.cB_addStorage_left;
			if (parseInt(utilitWidth) > params.p_w / 2) {
				exactCalculation = parseInt(params.p_h) + parseInt(params.p_r_p);
			} else {
				exactCalculation = parseInt(params.p_h + Math.ceil((params.p_r_p / (params.p_w / 2)) * utilitWidth));
			}
			if (exactCalculation > const_var.buildingHeightArray[const_var.buildingHeightArray.length - 1].value) {
				exactCalculation = const_var.buildingHeightArray[const_var.buildingHeightArray.length - 1].value;
			}
		}
		const_var.LNTCrossBracing = { left: [], right: [], front: [], back: [] };

		if (type == "addLeftLean") {
			if (params.add_left_front_lean_porch == true) {
				porchLengthSide = parseInt(params.leanF_p_w);
				const_var.UpdatedPriceData.front_lean_roof_style_price_changed = true;
				const_var.UpdatedPriceData.left_lean_roof_style_price_changed = true;
				const_var.UpdatedPriceData.left_front_wrap_connection_fee_changed = true;
			}
			if (params.add_left_back_lean_porch == true) {
				const_var.UpdatedPriceData.back_lean_roof_style_price_changed = true;
				const_var.UpdatedPriceData.left_lean_roof_style_price_changed = true;
				const_var.UpdatedPriceData.left_back_wrap_connection_fee_changed = true;
				porchLengthSide = parseInt(params.leanB_p_w);
			}
			if (params.add_left_front_lean_porch == true && params.add_left_back_lean_porch == true) {
				const_var.UpdatedPriceData.front_lean_roof_style_price_changed = true;
				const_var.UpdatedPriceData.back_lean_roof_style_price_changed = true;
				const_var.UpdatedPriceData.left_lean_roof_style_price_changed = true;
				const_var.UpdatedPriceData.left_front_wrap_connection_fee_changed = true;
				const_var.UpdatedPriceData.left_back_wrap_connection_fee_changed = true;

				porchLengthSide = parseInt(params.leanB_p_w) + parseInt(params.leanF_p_w);
			}
			const_var.UpdatedPriceData.left_lean_roof_style_price_changed = true;

			const_var.UpdatedPriceData.left_lean_back_wall_price_changed = true;
			const_var.UpdatedPriceData.left_lean_front_wall_price_changed = true;
			const_var.UpdatedPriceData.left_lean_left_wall_price_changed = true;
			const_var.UpdatedPriceData.left_lean_right_wall_price_changed = true;

			str = params.add_left_lean;
			var apiData = {
				width: params.lean_p_w,
				height: params.lean_p_h,
				length: params.lean_p_d + porchLengthSide,
				map_id: getMapIdForLeanTo("left"),
				roof_id: params.p_r_s,
				central_width: params.p_w,
				central_height: params.p_h,
				central_length: params.p_d,
				central_utility_length: params.p_u_c == true ? params.p_u_t : 0,
				central_utility_width: parseInt(utilitWidth),
				central_pitch_height: exactCalculation,
				utility_length: params.add_storage_check == true ? params.add_storage : 0,
				central_map_id: const_var.Map_Id[params.p_b_t],
				length_without_wrap: params.lean_p_d,
				pitch_type: `${params.b_l_t_r_p}_12`,
				central_pitch_type: `${params.p_r_p}_12`
			};
		}
		if (type == "addRightLean") {
			if (params.add_right_front_lean_porch == true) {
				porchLengthSide = parseInt(params.leanF_p_w);
				const_var.UpdatedPriceData.front_lean_roof_style_price_changed = true;
				const_var.UpdatedPriceData.right_lean_roof_style_price_changed = true;
				const_var.UpdatedPriceData.right_front_wrap_connection_fee_changed = true;
			}
			if (params.add_right_back_lean_porch == true) {
				const_var.UpdatedPriceData.back_lean_roof_style_price_changed = true;
				const_var.UpdatedPriceData.right_lean_roof_style_price_changed = true;
				const_var.UpdatedPriceData.right_back_wrap_connection_fee_changed = true;
				porchLengthSide = parseInt(params.leanB_p_w);
			}
			if (params.add_right_front_lean_porch == true && params.add_right_back_lean_porch == true) {
				const_var.UpdatedPriceData.front_lean_roof_style_price_changed = true;
				const_var.UpdatedPriceData.back_lean_roof_style_price_changed = true;
				const_var.UpdatedPriceData.right_lean_roof_style_price_changed = true;
				const_var.UpdatedPriceData.right_front_wrap_connection_fee_changed = true;
				const_var.UpdatedPriceData.right_back_wrap_connection_fee_changed = true;
				porchLengthSide = parseInt(params.leanB_p_w) + parseInt(params.leanF_p_w);
			}
			const_var.UpdatedPriceData.right_lean_roof_style_price_changed = true;

			const_var.UpdatedPriceData.right_lean_right_wall_price_changed = true;
			const_var.UpdatedPriceData.right_lean_back_wall_price_changed = true;
			const_var.UpdatedPriceData.right_lean_front_wall_price_changed = true;
			const_var.UpdatedPriceData.right_lean_left_wall_price_changed = true;

			str = params.add_right_lean;
			var apiData = {
				width: params.leanR_p_w,
				height: params.leanR_p_h,
				length: params.leanR_p_d + porchLengthSide,
				map_id: getMapIdForLeanTo("right"),
				roof_id: params.p_r_s,
				central_width: params.p_w,
				central_height: params.p_h,
				central_length: params.p_d,
				central_utility_length: params.p_u_c == true ? params.p_u_t : 0,
				central_utility_width: parseInt(utilitWidth),
				central_pitch_height: exactCalculation,
				utility_length: params.add_storage_check_right == true ? params.add_storage_right : 0,
				central_map_id: const_var.Map_Id[params.p_b_t],
				length_without_wrap: params.leanR_p_d,
				pitch_type: `${params.b_l_t_r_pR}_12`,
				central_pitch_type: `${params.p_r_p}_12`
			};
			if (const_var.b_o_J_1[params.p_b_t].includes("Free Standing Lean-to")) {
				apiData = {
					...apiData,
					...{
						central_single_slope_height:
							const_var.c_m_a[params.p_b_t] != undefined && const_var.c_m_a[params.p_b_t].fixed_new_leg_width != undefined && const_var.c_m_a[params.p_b_t].fixed_new_leg_width.length > 0
								? Math.floor(params.p_h - (params.p_w * params.p_r_p) / 12)
								: Math.round(params.p_h - (params.p_w * params.p_r_p) / 12)
					}
				};
			}
		}
		if (type == "addFrontLean") {
			if (params.add_right_front_lean_porch == true) {
				porchLengthEnd = parseInt(params.leanR_p_w);
				const_var.UpdatedPriceData.front_lean_roof_style_price_changed = true;
				const_var.UpdatedPriceData.right_lean_roof_style_price_changed = true;
				const_var.UpdatedPriceData.right_front_wrap_connection_fee_changed = true;
			}
			if (params.add_left_front_lean_porch == true) {
				const_var.UpdatedPriceData.front_lean_roof_style_price_changed = true;
				const_var.UpdatedPriceData.left_lean_roof_style_price_changed = true;
				const_var.UpdatedPriceData.left_front_wrap_connection_fee_changed = true;
				porchLengthEnd = parseInt(params.lean_p_w);
			}
			if (params.add_right_front_lean_porch == true && params.add_left_front_lean_porch == true) {
				const_var.UpdatedPriceData.front_lean_roof_style_price_changed = true;
				const_var.UpdatedPriceData.right_lean_roof_style_price_changed = true;
				const_var.UpdatedPriceData.left_lean_roof_style_price_changed = true;
				const_var.UpdatedPriceData.left_front_wrap_connection_fee_changed = true;
				const_var.UpdatedPriceData.right_front_wrap_connection_fee_changed = true;
				porchLengthEnd = parseInt(params.lean_p_w) + parseInt(params.leanR_p_w);
			}
			const_var.UpdatedPriceData.front_lean_roof_style_price_changed = true;

			const_var.UpdatedPriceData.front_lean_back_wall_price_changed = true;
			const_var.UpdatedPriceData.front_lean_front_wall_price_changed = true;
			const_var.UpdatedPriceData.front_lean_left_wall_price_changed = true;
			const_var.UpdatedPriceData.front_lean_right_wall_price_changed = true;

			str = params.add_front_lean;
			var apiData = {
				width: params.leanF_p_w,
				height: params.leanF_p_h,
				length: params.leanF_p_d + porchLengthEnd,
				map_id: getMapIdForLeanTo("front"),
				roof_id: params.p_r_s,
				central_width: params.p_w,
				central_height: params.p_h,
				central_length: params.p_d,
				central_utility_length: params.p_u_c == true ? params.p_u_t : 0,
				central_utility_width: parseInt(utilitWidth),
				central_pitch_height: exactCalculation,
				utility_length: params.add_storage_check_front == true ? params.add_storage_front : 0,
				central_map_id: const_var.Map_Id[params.p_b_t],
				length_without_wrap: params.leanF_p_d,
				pitch_type: `${params.b_l_t_r_pF}_12`,
				central_pitch_type: `${params.p_r_p}_12`,
				end_lean_tos_price: true
			};
		}
		const_var.CallApionAction = true;
		if (type == "addBackLean") {
			if (params.add_right_back_lean_porch == true) {
				const_var.UpdatedPriceData.back_lean_roof_style_price_changed = true;
				const_var.UpdatedPriceData.right_lean_roof_style_price_changed = true;
				const_var.UpdatedPriceData.right_back_wrap_connection_fee_changed = true;
				porchLengthEnd = parseInt(params.leanR_p_w);
			}
			if (params.add_left_back_lean_porch == true) {
				const_var.UpdatedPriceData.back_lean_roof_style_price_changed = true;
				const_var.UpdatedPriceData.left_lean_roof_style_price_changed = true;
				const_var.UpdatedPriceData.left_back_wrap_connection_fee_changed = true;
				porchLengthEnd = parseInt(params.lean_p_w);
			}
			if (params.add_right_back_lean_porch == true && params.add_left_back_lean_porch == true) {
				const_var.UpdatedPriceData.right_lean_roof_style_price_changed = true;
				const_var.UpdatedPriceData.back_lean_roof_style_price_changed = true;
				const_var.UpdatedPriceData.left_lean_roof_style_price_changed = true;
				const_var.UpdatedPriceData.right_back_wrap_connection_fee_changed = true;
				const_var.UpdatedPriceData.left_back_wrap_connection_fee_changed = true;
				porchLengthEnd = parseInt(params.lean_p_w) + parseInt(params.leanR_p_w);
			}
			const_var.UpdatedPriceData.back_lean_roof_style_price_changed = true;

			const_var.UpdatedPriceData.back_lean_left_wall_price_changed = true;
			const_var.UpdatedPriceData.back_lean_right_wall_price_changed = true;
			const_var.UpdatedPriceData.back_lean_back_wall_price_changed = true;
			const_var.UpdatedPriceData.back_lean_front_wall_price_changed = true;

			str = params.add_back_lean;
			var apiData = {
				width: params.leanB_p_w,
				height: params.leanB_p_h,
				length: params.leanB_p_d + porchLengthEnd,
				map_id: getMapIdForLeanTo("back"),
				roof_id: params.p_r_s,
				central_width: params.p_w,
				central_height: params.p_h,
				central_length: params.p_d,
				central_utility_length: params.p_u_c == true ? params.p_u_t : 0,
				central_utility_width: parseInt(utilitWidth),
				central_pitch_height: exactCalculation,
				utility_length: params.add_storage_check_back == true ? params.add_storage_back : 0,
				central_map_id: const_var.Map_Id[params.p_b_t],
				length_without_wrap: params.leanB_p_d,
				pitch_type: `${params.b_l_t_r_pB}_12`,
				central_pitch_type: `${params.p_r_p}_12`,
				end_lean_tos_price: true
			};
		}

		const_var.CallApionAction = true;
		const_var.isPriceAPIcalled = true;
		const_var.UpdatedPriceData.connection_fee_end_changed = true;
		const_var.UpdatedPriceData.connection_fee_side_changed = true;
		if (params.p_j_t == true) {
			const_var.UpdatedPriceData.common_length_changed = true;
			const_var.UpdatedPriceData.common_left_lean_length_changed = true;
			const_var.UpdatedPriceData.common_right_lean_length_changed = true;
			const_var.UpdatedPriceData.common_front_lean_length_changed = true;
			const_var.UpdatedPriceData.common_back_lean_length_changed = true;
		}
		const_var.UpdatedPriceData.certificate_price_changed = true;
		resetCheckBoxQuantityExtraBowsPrice();
		if (apiData != undefined) {
			apiData.gauge = const_var.g_v;
		}
		if (const_var.b_o_J_1[params.p_b_t] == "Custom Buildings") {
			apiData.is_lean_to_price = true;
		}

		let cutomBuildingData = const_var.defaultBuildingArr.filter((checkbuildtype) => checkbuildtype.leanto_data != undefined && checkbuildtype.leanto_data.right.length > 0);
		if (str != "") {
			const_var.legCutFlag = false;
			if (forLeanRoofReset != undefined) {
				let dataNew = "";
				if (type == "addLeftLean") {
					dataNew = const_var.leanGetDataLeft;
				}
				if (type == "addRightLean") {
					dataNew = const_var.leanGetDataRight;
				}
				if (type == "addFrontLean") {
					dataNew = const_var.leanGetDataFront;
				}
				if (type == "addBackLean") {
					dataNew = const_var.leanGetDataBack;
				}
				let tempRoof = "2";
				if (dataNew.roof_pitch != undefined && dataNew.roof_pitch.length > 0) {
					for (var i = 0; i <= dataNew.roof_pitch.length - 1; i++) {
						if (dataNew.roof_pitch[i].is_default == "yes" && forLeanRoofReset != undefined) {
							let buildingName =
								const_var.defaultBuildingArr[const_var.BuldingIDforReset] && const_var.defaultBuildingArr[const_var.BuldingIDforReset]?.image_name?.split(".")?.includes("Straight_Roof_Barns");

							let checkType =
								params.m_s_n == 3 &&
								buildingName &&
								((const_var.editAPIDataByResponse.data?.main_created_at >= "2024-07-01" && (const_var.crmSetting.is_Edit == true || const_var.isKLinkEnable == true)) ||
									const_var.loginSession == false ||
									const_var.loginSession == true)
									? true
									: false;
							tempRoof = dataNew.roof_pitch[i].roof_pitch.split("/")[0];
							if (checkType == true) {
								tempRoof = "3";
							}
						}
					}
					apiData.pitch_type = tempRoof + "_12";
				}
			}
			if (const_var.selSidingObj != {} && const_var.selSidingObj.name != "metal" && const_var.selSidingObj.price_type != "%") {
				if (const_var.selSidingObj.name == const_var.selSidingOption) {
					apiData.side_end_name = const_var.selSidingObj.name;
				}
			}
			if (params.m_s_n == 122 && const_var.selSidingObj != {} && const_var.selSidingObj.name.includes("board_and_batten")) {
				apiData.send_default_data = true;
			}

			if (type === "addLeftLean" && params.leanStyle.left === "gable") {
				apiData.is_l_and_t_building = true;
			}
			if (type === "addRightLean" && params.leanStyle.right === "gable") {
				apiData.is_l_and_t_building = true;
			}
			if (type === "addFrontLean" && params.leanStyle.front === "gable") {
				apiData.is_l_and_t_building = true;
				apiData.end_lean_tos_price = true;
			}
			if (type === "addBackLean" && params.leanStyle.back === "gable") {
				apiData.is_l_and_t_building = true;
				apiData.end_lean_tos_price = true;
			}
			let checkDollarExist = const_var.c_m_a?.[const_var.post_data.building.building_type]?.wainscot_details?.find((wain) => wain?.name && params.wainscotTexture?.includes(wain?.name));
			if (params.p_w_c_n && checkDollarExist?.price_type == "$" && params.wainscotTexture != "metal") {
				apiData.applicable_wainscot = applicableWainscot();
			}

			return async (dispatch) => {
				const response = await getLeanToBuildingPricing();

				// Reset extra add on price on Dimension change
				if (response?.data?.success == true && response?.data?.data) {
					let addOnItems = const_var.extraAddOnItemsArray?.map((item) => {
						if (item) {
							return item.label;
						}
					});

					const_var.UpdatedPriceData.left_lean_utility_price_changed = true;
					const_var.UpdatedPriceData.left_lean_front_wall_price_changed = true;
					const_var.UpdatedPriceData.left_lean_left_wall_price_changed = true;
					const_var.UpdatedPriceData.left_lean_back_wall_price_changed = true;

					const_var.UpdatedPriceData.right_lean_utility_price_changed = true;
					const_var.UpdatedPriceData.right_lean_front_wall_price_changed = true;
					const_var.UpdatedPriceData.right_lean_right_wall_price_changed = true;
					const_var.UpdatedPriceData.right_lean_back_wall_price_changed = true;

					const_var.UpdatedPriceData.back_lean_utility_price_changed = true;
					const_var.UpdatedPriceData.back_lean_back_wall_price_changed = true;
					const_var.UpdatedPriceData.back_lean_front_wall_price_changed = true;
					const_var.UpdatedPriceData.back_lean_left_wall_price_changed = true;

					const_var.UpdatedPriceData.front_lean_utility_price_changed = true;
					const_var.UpdatedPriceData.front_lean_front_wall_price_changed = true;
					const_var.UpdatedPriceData.front_lean_back_wall_price_changed = true;
					const_var.UpdatedPriceData.front_lean_left_wall_price_changed = true;

					if (const_var.stateData?.fetch_price_for?.surcharge && const_var.surcharge_amount_is_edit != true) {
						const_var.UpdatedPriceData.surcharge_amount = undefined;
					}

					if (params.m_s_n == 122 && const_var.selSidingObj != {} && const_var.selSidingObj.name.includes("board_and_batten") && response?.data?.data) {
						setZeroPriceOverhang(response.data.data);
					}

					const_var.onDragUtilityPriceUpdateLeft = false;
					const_var.onDragUtilityPriceUpdateRight = false;
					const_var.onDragUtilityPriceUpdateFront = false;
					const_var.onDragUtilityPriceUpdateBack = false;
					const_var.onDragUtilityPriceUpdateCenterBuilding = false;
					const_var.isWainscotManualPriceUpdate = false;

					const_var.engineer_drawings_price_changed = true;
					const_var.showDisabledClass = false;
					const_var.installationsurfaceChange = true;
					const_var.is_edit_labour = undefined;
					if (params.m_s_n == 11 || params.m_s_n == 54 || params.m_s_n == 147 || params.m_s_n == 160) {
						const_var.isCheckGroundCertificate = true;
					}
					utils.prepareLoftDropdown();
					// utils.handleSelectionIndexingForExtraAddOn(response.data?.data, type);
					// utils.handleSelectionIndexingForAdditionFeature(response.data?.data, type);
					const_var.isUpdate4ftLegLogic = /* true */ params.m_s_n == 3 ? true : false;
					if (response.data.success == false) {
						dispatch(setPricingDataForLeanto(Constant.customLeantoPriceData, type));
						const_var.UpdatedPriceData.insulation_price_changed = true;
					} else {
						const_var.holdPricingResponseLean = response.data;

						if (const_var.insulationJsonLeanTo.length == 0 && response.data.data?.insulation) {
							for (var i = 0; i < response.data.data.insulation.length; i++) {
								const_var.insulationJsonLeanTo[response.data.data.insulation[i].insulation_id] = response.data.data.insulation[i].name;
							}
						} else {
							const_var.insulationJsonLeanTo = [];
							if (response.data != undefined && response.data.data != undefined) {
								for (var i = 0; i < response.data.data.insulation.length; i++) {
									const_var.insulationJsonLeanTo[response.data.data.insulation[i].insulation_id] = response.data.data.insulation[i].name;
								}
							}
						}

						if (type == "addLeftLean") {
							if (const_var.crmSetting.is_Edit == false) {
								checkleanLegsDataAccordingtoResponse(response.data.data?.building_structure[0]?.conditions["Leg_Height_condition"], "left");
							}
							if (legstype == undefined) {
								checkleanLegsDataAccordingtoResponse(response.data.data?.building_structure[0]?.conditions["Leg_Height_condition"], "left", "dimension");
							}
							const_var.UpdatedPriceData.left_lean_insulation_price_changed = true;
							const_var.UpdatedPriceData.left_lean_roof_style_price_changed = true;
							const_var.UpdatedPriceData.left_lean_height_price_changed = true;
							const_var.UpdatedPriceData.connection_fee_side_changed = true;
							const_var.UpdatedPriceData.connection_fee_end_changed = true;
							if (params.add_left_front_lean_porch) const_var.UpdatedPriceData.left_front_wrap_connection_fee_changed = true;
							if (params.add_left_back_lean_porch) const_var.UpdatedPriceData.left_back_wrap_connection_fee_changed = true;
							if (params.add_left_front_lean_porch && params.add_left_back_lean_porch) {
								const_var.UpdatedPriceData.left_front_wrap_connection_fee_changed = true;
								const_var.UpdatedPriceData.left_back_wrap_connection_fee_changed = true;
							}

							checkAndupdateOtherInsulationSelection(response.data.data.insulation);
						}
						if (type == "addRightLean") {
							if (const_var.crmSetting.is_Edit == false) {
								checkleanLegsDataAccordingtoResponse(response.data.data?.building_structure[0]?.conditions["Leg_Height_condition"], "right");
							}
							if (legstype == undefined) {
								checkleanLegsDataAccordingtoResponse(response.data.data?.building_structure[0]?.conditions["Leg_Height_condition"], "right", "dimension");
							}
							const_var.UpdatedPriceData.right_lean_insulation_price_changed = true;
							const_var.UpdatedPriceData.right_lean_roof_style_price_changed = true;
							const_var.UpdatedPriceData.right_lean_height_price_changed = true;
							const_var.UpdatedPriceData.connection_fee_side_changed = true;
							const_var.UpdatedPriceData.connection_fee_end_changed = true;
							if (params.add_right_front_lean_porch) const_var.UpdatedPriceData.right_front_wrap_connection_fee_changed = true;
							if (params.add_right_back_lean_porch) const_var.UpdatedPriceData.right_back_wrap_connection_fee_changed = true;
							if (params.add_right_front_lean_porch && params.add_right_back_lean_porch) {
								const_var.UpdatedPriceData.right_front_wrap_connection_fee_changed = true;
								const_var.UpdatedPriceData.right_back_wrap_connection_fee_changed = true;
							}

							checkAndupdateOtherInsulationSelection(response.data.data.insulation);
						}
						if (type == "addFrontLean") {
							if (const_var.crmSetting.is_Edit == false) {
								checkleanLegsDataAccordingtoResponse(response.data.data?.building_structure[0]?.conditions["Leg_Height_condition"], "front");
							}
							if (legstype == undefined) {
							checkleanLegsDataAccordingtoResponse(response.data.data?.building_structure[0]?.conditions["Leg_Height_condition"], "front", "dimension");
							}
							const_var.UpdatedPriceData.front_lean_insulation_price_changed = true;
							const_var.UpdatedPriceData.front_lean_roof_style_price_changed = true;
							const_var.UpdatedPriceData.front_lean_height_price_changed = true;
							const_var.UpdatedPriceData.connection_fee_side_changed = true;
							const_var.UpdatedPriceData.connection_fee_end_changed = true;
							if (params.add_left_front_lean_porch) const_var.UpdatedPriceData.left_front_wrap_connection_fee_changed = true;
							if (params.add_right_front_lean_porch) const_var.UpdatedPriceData.right_front_wrap_connection_fee_changed = true;
							if (params.add_right_front_lean_porch && params.add_left_front_lean_porch) {
								const_var.UpdatedPriceData.left_front_wrap_connection_fee_changed = true;
								const_var.UpdatedPriceData.right_front_wrap_connection_fee_changed = true;
							}
							if (params.insulation.frontLean.insulationId != 0) {
								if (response?.data?.data?.insulation && const_var.isInsulaltionForOldQuotes == false && const_var.crmSetting.is_Edit == true) {
									if (response.data.data.insulation.length > 0 && response.data.data.insulation.filter((obj) => obj.insulation_id == params.insulation.frontLean.insulationId).length == 0) {
										params.insulation.frontLean.insulationId = response.data.data.insulation[0].insulation_id; //0
									}
									if (response.data.data.insulation.length == 0) {
										params.insulation.frontLean.insulationId = 0;
									}
								}
							}
							checkAndupdateOtherInsulationSelection(response.data.data.insulation);
						}
						if (type == "addBackLean") {
							if (const_var.crmSetting.is_Edit == false) {
								checkleanLegsDataAccordingtoResponse(response.data.data?.building_structure[0]?.conditions["Leg_Height_condition"], "back");
							}
							if (legstype == undefined) {
								checkleanLegsDataAccordingtoResponse(response.data.data?.building_structure[0]?.conditions["Leg_Height_condition"], "back", "dimension");
							}
							const_var.UpdatedPriceData.back_lean_insulation_price_changed = true;
							const_var.UpdatedPriceData.back_lean_roof_style_price_changed = true;
							const_var.UpdatedPriceData.back_lean_height_price_changed = true;
							const_var.UpdatedPriceData.connection_fee_side_changed = true;
							const_var.UpdatedPriceData.connection_fee_end_changed = true;
							if (params.add_right_back_lean_porch) const_var.UpdatedPriceData.right_back_wrap_connection_fee_changed = true;
							if (params.add_left_back_lean_porch) const_var.UpdatedPriceData.left_back_wrap_connection_fee_changed = true;
							if (params.add_right_back_lean_porch && params.add_left_back_lean_porch == true) {
								const_var.UpdatedPriceData.right_back_wrap_connection_fee_changed = true;
								const_var.UpdatedPriceData.left_back_wrap_connection_fee_changed = true;
							}

							if (params.insulation.backLean.insulationId != 0) {
								if (response?.data?.data?.insulation && const_var.isInsulaltionForOldQuotes == false && const_var.crmSetting.is_Edit == true) {
									if (response.data.data.insulation.length > 0 && response.data.data.insulation.filter((obj) => obj.insulation_id == params.insulation.backLean.insulationId).length == 0) {
										params.insulation.backLean.insulationId = response.data.data.insulation[0].insulation_id; //0
									}
									if (response.data.data.insulation.length == 0) {
										params.insulation.backLean.insulationId = 0;
									}
								}
							}
							checkAndupdateOtherInsulationSelection(response.data.data.insulation);
						}
						if (flag == undefined) {
							const_var.checkforLeanto = true;
						}

						legstype == "checkLegs" ? (const_var.checkForLeantoLegs = true) : (const_var.checkForLeantoLegs = false);
						const_var.UpdatedPriceData.certificate_price_changed = true;
						const_var.UpdatedPriceData.wainscot_price_changed = true;

						const_var.UpdatedPriceData.roof_color_price_changed = true;
						const_var.UpdatedPriceData.wall_color_price_changed = true;
						const_var.UpdatedPriceData.trim_color_price_changed = true;
						const_var.UpdatedPriceData.certificate_price_changed = true;
						const_var.UpdatedPriceData.left_lean_roof_pitch_price_changed = true;
						const_var.UpdatedPriceData.right_lean_roof_pitch_price_changed = true;
						const_var.UpdatedPriceData.front_lean_roof_pitch_price_changed = true;
						const_var.UpdatedPriceData.back_lean_roof_pitch_price_changed = true;
						const_var.UpdatedPriceData.front_lean_insulation_price_changed = true;
						const_var.UpdatedPriceData.left_lean_insulation_price_changed = true;
						const_var.UpdatedPriceData.back_lean_insulation_price_changed = true;
						const_var.UpdatedPriceData.right_lean_insulation_price_changed = true;
						const_var.UpdatedPriceData.surcharge_amount = undefined;
						if (chk == "updateUtilityOnly" && (params?.p_u_c || params.add_storage_check || params.add_storage_check_right || params.add_storage_check_front || params.add_storage_check_back)) {
							let callFor = "";
							if (type == "addLeftLean") {
								callFor = "leanGetDataLeft";
							}
							if (type == "addRightLean") {
								callFor = "leanGetDataRight";
							}
							if (type == "addFrontLean") {
								callFor = "leanGetDataFront";
							}
							if (type == "addBackLean") {
								callFor = "leanGetDataBack";
							}
							const_var[callFor].utility_delux_two_tone = response.data.data.utility_delux_two_tone;
							const_var[callFor].utility_side = response.data.data.utility_side;
							if (const_var?.leanto?.length > 0) {
								const_var.leanto?.forEach((item) => {
									if (item?.leanto_type == 1 && type == "addLeftLean" && params.add_storage_check) {
										item.pricing_data.utility_side = response.data.data.utility_side;
										item.pricing_data.utility_delux_two_tone = response.data.data.utility_delux_two_tone;
									}
									if (item?.leanto_type == 2 && type == "addRightLean" && params.add_storage_check_right) {
										item.pricing_data.utility_side = response.data.data.utility_side;
										item.pricing_data.utility_delux_two_tone = response.data.data.utility_delux_two_tone;
									}
									if (item?.leanto_type == 3 && type == "addFrontLean" && params.add_storage_check_front) {
										item.pricing_data.utility_side = response.data.data.utility_side;
										item.pricing_data.utility_delux_two_tone = response.data.data.utility_delux_two_tone;
									}
									if (item?.leanto_type == 4 && type == "addBackLean" && params.add_storage_check_back) {
										item.pricing_data.utility_side = response.data.data.utility_side;
										item.pricing_data.utility_delux_two_tone = response.data.data.utility_delux_two_tone;
									}
								});
								const_var.a_p_d_a.utility_side = response.data.data.central_utility_side;
							}
							if (type == "addLeftLean" && params.add_storage_check) {
								cuBuilding.cPforLLeanOnly(const_var[callFor]);
							}
							if (type == "addRightLean" && params.add_storage_check_right) {
								cuBuilding.cPforRLeanOnly(const_var[callFor]);
							}
							if (type == "addFrontLean" && params.add_storage_check_front) {
								cuBuilding.cPforFLeanOnly(const_var[callFor]);
							}
							if (type == "addBackLean" && params.add_storage_check_back) {
								cuBuilding.cPforBLeanOnly(const_var[callFor]);
							}
							cuBuilding.cP();
						} else {
							dispatch(setPricingDataForLeanto(response.data, type));
							cuBuilding.cP();
						}

						const_var.legCutFlag = true;
					}

					if (const_var.UpdatedPriceData.connection_fee_side_changed != true) {
						const_var.UpdatedPriceData.connection_fee_side_changed = true;
						const_var.UpdatedPriceData.wainscot_price_changed = true;
					}
				}
			};
		} else {
			return (dispatch) => {
				const_var.UpdatedPriceData.surcharge_amount = undefined;
				const_var.UpdatedPriceData.wainscot_price_changed = true;

				const_var.UpdatedPriceData.roof_color_price_changed = true;
				const_var.UpdatedPriceData.wall_color_price_changed = true;
				const_var.UpdatedPriceData.trim_color_price_changed = true;
				if (type == "addFrontLean") {
					// utils.handleSelectionIndexingForExtraAddOn(const_var.leanGetDataFront, type);
					// utils.handleSelectionIndexingForAdditionFeature(const_var.leanGetDataFront, type);
					dispatch(setPricingDataForLeanto(const_var.leanGetDataFront, type));
				}
				if (type == "addBackLean") {
					// utils.handleSelectionIndexingForExtraAddOn(const_var.leanGetDataBack, type);
					// utils.handleSelectionIndexingForAdditionFeature(const_var.leanGetDataBack, type);
					dispatch(setPricingDataForLeanto(const_var.leanGetDataBack, type));
				} else {
					// utils.handleSelectionIndexingForExtraAddOn(type == "addLeftLean" ? const_var.leanGetDataLeft : const_var.leanGetDataRight, type);
					// utils.handleSelectionIndexingForAdditionFeature(type == "addLeftLean" ? const_var.leanGetDataLeft : const_var.leanGetDataRight, type);
					dispatch(setPricingDataForLeanto(type == "addLeftLean" ? const_var.leanGetDataLeft : const_var.leanGetDataRight, type));
				}
			};
		}
	}

	return getPricingDataForLeanto;
};
export function addLeantoSection(e, str, leftFront, rightFront, leftBack, rightBack) {
	return async (dispatch) => {
		let response = null;

		["front", "back", "left", "right"].forEach((leanType) => {
			if (params[`add_${leanType}_lean`] && `add${leanType}lean` === str.toLowerCase()) {
				const_var.lNTBuildingData.ExtraItemsFeaturesArrayForOverhangComputation[leanType] = [];
			}
		});

		if (params[`add_${const_var.selectedLeanType}_lean`] && `add${const_var.selectedLeanType}lean` === str.toLowerCase()) {
			dispatch(selectCenterBuilding());
		}
		if (!const_var.isTBSOldQuotesForVerticalRoof && params.m_s_n == 13 && params.p_r_s !== 3 && (str == "addFrontLean" || str == "addBackLean")) {
			dispatch({
				type: "addLeantoSection",
				event: e,
				value: "endLeantosForTubulerBuildingMnf"
			});
		} else {
			dispatch({
				type: "addLeantoSection",
				event: e,
				value: str
			});
			response = await dispatch(getPricingDataForLeanto(e, str));

			if (leftFront || rightFront || leftBack || rightBack) {
				dispatch(handleLeanPorchPrices(leftFront, rightFront, leftBack, rightBack));
			}
		}
		return response;
	};
}
export function addLeantoPorches(e, str, chk, isFrontLeanAdded, isLeftLeanAdded, isRightLeanAdded, isBackLeanAdded, key) {
	if (!const_var.isTBSOldQuotesForVerticalRoof && params.m_s_n == 13 && params.p_r_s !== 3) {
		return (dispatch) => {
			dispatch({
				type: "addLeantoPorches",
				event: e,
				value: "endLeantoPorchessForTubulerBuildingMnf"
			});
		};
	} else {
		return (dispatch) => {
			batch(() => {
				dispatch({
					type: "addLeantoPorches",
					event: e,
					value: str,
					key: key
				});

				if (key != undefined && key == "FullBuilding") {
					if (params.add_full_lean_porch == true) {
						params.lean_p_d = params.p_d;
						params.leanR_p_d = params.p_d;
						params.leanF_p_d = params.p_w;
						params.leanB_p_d = params.p_w;
						params.add_right_front_lean_porch = true;
						params.add_right_back_lean_porch = true;
						params.add_left_front_lean_porch = true;
						params.add_left_back_lean_porch = true;
					} else {
						params.add_right_front_lean_porch = false;
						params.add_right_back_lean_porch = false;
						params.add_left_front_lean_porch = false;
						params.add_left_back_lean_porch = false;
					}
				}
				if (chk != undefined && (const_var.isShowAlert == false || (const_var.isShowAlert == true && const_var.alertUsedFor == "DoorHeightGreaterThanLentoHeight"))) {
					if (str == "addLeftFrontLeanToPorch") {
						dispatch(getPricingDataForLeanto(e, "addFrontLean", params.lean_p_w, false, isFrontLeanAdded ? "checkLegs" : undefined));
						dispatch(getPricingDataForLeanto(e, "addLeftLean", params.leanF_p_w, false, isLeftLeanAdded ? "checkLegs" : undefined));
					}
					if (str == "addRightFrontLeanToPorch") {
						dispatch(getPricingDataForLeanto(e, "addFrontLean", params.leanR_p_w, false, isFrontLeanAdded ? "checkLegs" : undefined));
						dispatch(getPricingDataForLeanto(e, "addRightLean", params.leanF_p_w, false, isRightLeanAdded ? "checkLegs" : undefined));
					}
					if (str == "addLeftBackLeanToPorch") {
						dispatch(getPricingDataForLeanto(e, "addBackLean", params.lean_p_w, false, isBackLeanAdded ? "checkLegs" : undefined));
						dispatch(getPricingDataForLeanto(e, "addLeftLean", params.leanB_p_w, false, isLeftLeanAdded ? "checkLegs" : undefined));
					}
					if (str == "addRightBackLeanToPorch") {
						dispatch(getPricingDataForLeanto(e, "addBackLean", params.leanR_p_w, false, isBackLeanAdded ? "checkLegs" : undefined));
						dispatch(getPricingDataForLeanto(e, "addRightLean", params.leanB_p_w, false, isRightLeanAdded ? "checkLegs" : undefined));
					}
				}
			});
		};
	}
}
